export default __webpack_public_path__ + "./images/mx.26ae488b.png";